import { ERROR_NOTIFICATION } from "constants/errors";

export const errorNotification = (error) => async (dispatch) =>
  dispatch({
    type: ERROR_NOTIFICATION,
    payload: error,
  });
